"use strict";
/** @jsx jsx */

var _defineProperty = require("/mnt/ephemeral/jenkins/workspace/lucid-co-gatsby/corporate/node_modules/gatsby/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/defineProperty");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var core_1 = require("@emotion/core");

var styled_1 = __importDefault(require("../../../theme/styled"));

var utils_1 = require("../../../utils/utils");

var NavbarWrap = styled_1.default.nav(function (_ref) {
  var theme = _ref.theme,
      sticky = _ref.sticky,
      stickyCollapsed = _ref.stickyCollapsed,
      background = _ref.background,
      top = _ref.top,
      zIndex = _ref.zIndex;
  return _defineProperty({
    display: 'block',
    background: background || theme.navbar.background,
    zIndex: zIndex,
    top: top,
    left: 0,
    right: 0,
    position: sticky ? ['fixed', 'sticky'] : 'relative'
  }, "@media (max-width: ".concat(theme.navbar.collapseAt, ")"), {
    position: stickyCollapsed ? ['fixed', 'sticky'] : 'relative'
  });
});
var IE11 = utils_1.isIE11();

var NavbarWrapper = function NavbarWrapper(_ref3) {
  var as = _ref3.as,
      _ref3$sticky = _ref3.sticky,
      sticky = _ref3$sticky === void 0 ? false : _ref3$sticky,
      _ref3$stickyCollapsed = _ref3.stickyCollapsed,
      stickyCollapsed = _ref3$stickyCollapsed === void 0 ? false : _ref3$stickyCollapsed,
      _ref3$top = _ref3.top,
      top = _ref3$top === void 0 ? 0 : _ref3$top,
      _ref3$zIndex = _ref3.zIndex,
      zIndex = _ref3$zIndex === void 0 ? 1000 : _ref3$zIndex,
      background = _ref3.background,
      children = _ref3.children;
  return core_1.jsx(NavbarWrap, {
    as: as,
    sticky: sticky,
    stickyCollapsed: stickyCollapsed,
    top: top,
    zIndex: zIndex,
    background: background,
    css: {
      label: 'navbarWrapper'
    }
  }, sticky && IE11 && core_1.jsx(core_1.Global, {
    styles: {
      body: {
        marginTop: '60px'
      }
    }
  }), children);
};

exports.default = NavbarWrapper;